import React, { useState, useEffect } from "react";
import { Container, Grid, Skeleton } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import * as courseService from "../../services/CourseService";
import CourseCard from "./components/CourseCard";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import Notification from "../../../../components/mui/Notification";
import NewCard from "../../../../components/NewCard";
import PageHeader from "../../../../components/PageHeader";
import {
  CASE_STUDY_LIST,
  INSTRUCTOR_BOARD_ROUTE,
  INSTRUCTOR_COURSE_UPSERT_ROUTE,
} from "../../helper/Constants";
import { useTranslation } from "react-i18next";

export default function List() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { state } = useLocation();
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [loading, setLoading] = useState(true);
  const [courses, setCourses] = useState([]);
  const institutionId = state.institutionId;

  useEffect(() => {
    // if (!isEpmty(state)) {
    // const eventId = state.eventId;
    // setEventId(eventId);
    courseService
      .getAll(institutionId)
      .then((response) => {
        setCourses(response.data);
      })
      .catch((e) => {
        console.error(`Error: ${e.message}`);
        setNotify({
          isOpen: true,
          message: t("server_error_default"),
          type: "error",
        });
      })
      .finally(() => setLoading(false));
    // } else setLoading(false);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onDelete = (id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    courseService
      .del(id)
      .then(() => {
        const newCourses = courses.filter((item) => item.id !== id);
        setCourses(newCourses);
        setNotify({
          isOpen: true,
          message: t("item_deletion_success"),
          type: "success",
        });
      })
      .catch((e) => {
        console.error(`Error: ${e.message}`);
        setNotify({
          isOpen: true,
          message: t("course_delete_error"),
          type: "error",
        });
      });
  };

  const handleDelete = (id) => {
    setConfirmDialog({
      isOpen: true,
      title: t("item_deletion_dialog_title"),
      subTitle: t("item_deletion_dialog_subtitle"),
      onConfirm: () => {
        onDelete(id);
      },
    });
  };

  const handleCasestudy = (course) => {
    navigate(CASE_STUDY_LIST, { state: { course, institutionId } });
  };

  const handleEdit = (course) => {
    navigate(INSTRUCTOR_COURSE_UPSERT_ROUTE, {
      state: { course, editMode: true, institutionId },
    });
  };

  const handleNew = () => {
    navigate(INSTRUCTOR_COURSE_UPSERT_ROUTE, {
      state: { institutionId },
    });
  };

  const handleBackButton = () => {
    navigate(INSTRUCTOR_BOARD_ROUTE);
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <PageHeader
        title={t("course_list_title")}
        isChild={true}
        backHandler={() => handleBackButton()}
      />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <NewCard title={t("course_list_new_title")} onclick={handleNew} />
        </Grid>
        {loading
          ? Array.from(new Array(3)).map((item, index) => (
              <Grid
                key={index}
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                sx={{ mt: 2 }}
              >
                <Skeleton variant="rectangular" height={118} />
                <Skeleton />
                <Skeleton width="60%" />
              </Grid>
            ))
          : courses.map((course, index) => (
              <Grid key={index} item xs={12} sm={6} md={4} lg={3}>
                <CourseCard
                  course={course}
                  handleEdit={() => handleEdit(course)}
                  handleDelete={handleDelete}
                  handleCasestudy={() => handleCasestudy(course)}
                />
              </Grid>
            ))}
      </Grid>
      <Notification notify={notify} setNotify={setNotify} />
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </Container>
  );
}
